<template>
  <div class="wrraper custom_card">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />

    <!-- End Breadcrumb -->
    <MainLoader v-if="loading"></MainLoader>
    <div class="row details_section" v-else>
      <h6>{{ blogData.title }}</h6>
      <span>
        {{ blogData.type }} | {{ blogData.views }} views |
        {{ blogData.published_at }}</span
      >
      <div class="details_section col-lg-12">
        <img :src="blogData.image" />
      </div>
      <p>
        {{ blogData.description }}
      </p>
      <div
        class="details_section col-lg-6"
        v-for="section in blogData.blog_contents"
        :key="section.id"
      >
        <h2>{{ section.title }}</h2>
        <img :src="section.image" />
        <p>{{ section.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RatingStars from "@/components/UI/RatingStars.vue";
import UserRate from "@/components/Global/UserRate.vue";

export default {
  props: ["id"],
  components: {
    RatingStars,
    UserRate,
  },
  data() {
    return {
      selectedColor: null,
      selectedSize: null,

      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.blogs.title"),
          disabled: false,
          href: "/blogs",
        },
        {
          text: this.$t("breadcrumb.blogs.show"),
          disabled: true,
          href: "",
        },
      ],

      //Data
      blogData: null,
      loading: false,

      // ========== Table
    };
  },

  watch: {
    // [`paginations.current_page`]() {},
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },

  methods: {
    //Get Prosuct
    getBlog() {
      this.axios({
        method: "GET",
        url: `blog/${this.id}`,
      })
        .then((res) => {
          this.blogData = res.data.data;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/blogs" });
          this.loadingPage = false;
        });
    },
  },

  // ======= hooks
  mounted() {
    this.getBlog();
  },
};
</script>

<style lang="scss" scoped>
span.color {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
}
.details_section {
  margin-bottom: 25px;
  h2 {
    font-weight: 700;
    @include homeSecondTitle;
    font-size: 30px;
  }
  span {
    font-size: 13px;
    color: #8f98c5;
    margin-bottom: 15px;
    display: inline-block;
  }
  img {
    width: 100%;
    height: 500px;
    border-radius: 15px;
  }
  p {
    color: black;
    font-size: 16px;
    margin-top: 20px;
    // font-family: $medium_font;
    font-weight: 500;
    line-height: 30px;
  }
  h2 {
    font-weight: 700;
    @include homeSecondTitle;
    font-size: 30px;
    line-height: 50px;
  }
  h6 {
    @include homeFirstTitle;
    font-size: 18px;
    // font-family: $semi_bold_font;
    // color: black;
  }
  span {
    @include homeFirstTitle;
    font-size: 14px;
    color: #8f98c5;
    display: inline-block;
  }
}
</style>
